// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modalWrapper__Cq09CpKX","codatLink":"codatLink__ZGW18KeK"};